/**
 * @generated SignedSource<<350d0e33d710d7fcdf659b8c712196b6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SavedViewUpdatesQuery$variables = {
  isNavRefreshEnabled: boolean;
  viewUuid: string;
  workspaceUuid: string;
};
export type SavedViewUpdatesQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SavedViewSidebarColumn" | "SavedViewUpdatesMainColumn">;
};
export type SavedViewUpdatesQuery = {
  response: SavedViewUpdatesQuery$data;
  variables: SavedViewUpdatesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isNavRefreshEnabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewUuid"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUuid"
},
v3 = {
  "kind": "Variable",
  "name": "viewUuid",
  "variableName": "viewUuid"
},
v4 = {
  "kind": "Variable",
  "name": "workspaceUuid",
  "variableName": "workspaceUuid"
},
v5 = [
  (v3/*: any*/),
  (v4/*: any*/)
],
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v9 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  (v3/*: any*/),
  (v4/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v12 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v13 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v14 = {
  "kind": "ScalarField",
  "name": "picture"
},
v15 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v16 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v17 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v7/*: any*/),
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": [
        (v14/*: any*/),
        (v15/*: any*/),
        (v6/*: any*/),
        (v16/*: any*/)
      ]
    }
  ]
},
v18 = {
  "kind": "ScalarField",
  "name": "ari"
},
v19 = {
  "concreteType": "Workspace",
  "kind": "LinkedField",
  "name": "workspace",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v7/*: any*/)
  ]
},
v20 = {
  "kind": "ScalarField",
  "name": "watching"
},
v21 = {
  "kind": "ScalarField",
  "name": "key"
},
v22 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v23 = [
  (v7/*: any*/),
  (v22/*: any*/)
],
v24 = {
  "kind": "ScalarField",
  "name": "latestUpdateDate"
},
v25 = {
  "kind": "ScalarField",
  "name": "type"
},
v26 = {
  "kind": "ScalarField",
  "name": "summary"
},
v27 = [
  (v21/*: any*/),
  (v18/*: any*/),
  (v7/*: any*/)
],
v28 = [
  {
    "concreteType": "UserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      (v6/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/)
    ]
  },
  (v13/*: any*/),
  (v7/*: any*/)
],
v29 = {
  "kind": "ScalarField",
  "name": "count"
},
v30 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v31 = {
  "concreteType": "CommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "CommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "Comment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            (v30/*: any*/),
            (v18/*: any*/),
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v22/*: any*/),
            {
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v13/*: any*/),
                {
                  "concreteType": "UserPII",
                  "kind": "LinkedField",
                  "name": "pii",
                  "plural": false,
                  "selections": [
                    (v14/*: any*/),
                    (v6/*: any*/),
                    (v16/*: any*/),
                    (v15/*: any*/)
                  ]
                },
                (v7/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ]
},
v32 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": [
        (v6/*: any*/)
      ]
    },
    (v7/*: any*/)
  ]
},
v33 = {
  "kind": "ScalarField",
  "name": "label"
},
v34 = [
  {
    "kind": "ScalarField",
    "name": "messageId"
  }
],
v35 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v34/*: any*/)
},
v36 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v37 = [
  {
    "kind": "ScalarField",
    "name": "confidence"
  },
  (v33/*: any*/),
  (v35/*: any*/),
  {
    "alias": "tooltip",
    "args": (v36/*: any*/),
    "kind": "ScalarField",
    "name": "label",
    "storageKey": "label(longFormat:true)"
  },
  {
    "alias": "localizedTooltip",
    "args": (v36/*: any*/),
    "concreteType": "LocalizationField",
    "kind": "LinkedField",
    "name": "localizedLabel",
    "plural": false,
    "selections": (v34/*: any*/),
    "storageKey": "localizedLabel(longFormat:true)"
  },
  {
    "kind": "ScalarField",
    "name": "overdue"
  }
],
v38 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "newDueDate",
  "plural": false,
  "selections": (v37/*: any*/)
},
v39 = {
  "alias": "projectStateValue",
  "kind": "ScalarField",
  "name": "value"
},
v40 = {
  "kind": "ScalarField",
  "name": "value"
},
v41 = {
  "concreteType": "CompletionProjectState",
  "kind": "LinkedField",
  "name": "atCompletionState",
  "plural": false,
  "selections": [
    (v40/*: any*/),
    (v33/*: any*/),
    (v35/*: any*/)
  ]
},
v42 = {
  "kind": "ScalarField",
  "name": "archived"
},
v43 = {
  "kind": "ScalarField",
  "name": "title"
},
v44 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "oldDueDate",
  "plural": false,
  "selections": (v37/*: any*/)
},
v45 = {
  "kind": "ScalarField",
  "name": "url"
},
v46 = [
  (v7/*: any*/)
],
v47 = {
  "kind": "ScalarField",
  "name": "score"
},
v48 = {
  "alias": "goalStateValue",
  "kind": "ScalarField",
  "name": "value"
},
v49 = {
  "args": [
    {
      "kind": "Literal",
      "name": "includeScore",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "label",
  "storageKey": "label(includeScore:false)"
},
v50 = {
  "concreteType": "CompletionGoalState",
  "kind": "LinkedField",
  "name": "atCompletionState",
  "plural": false,
  "selections": [
    (v49/*: any*/),
    (v35/*: any*/),
    (v40/*: any*/),
    (v47/*: any*/)
  ]
},
v51 = [
  (v40/*: any*/),
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "SavedViewUpdatesQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "kind": "FragmentSpread",
        "name": "SavedViewUpdatesMainColumn"
      },
      {
        "condition": "isNavRefreshEnabled",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "kind": "FragmentSpread",
            "name": "SavedViewSidebarColumn"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SavedViewUpdatesQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "uuid",
            "variableName": "viewUuid"
          },
          (v4/*: any*/)
        ],
        "concreteType": "DirectoryView",
        "kind": "LinkedField",
        "name": "directoryViewByUuid",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "ScalarField",
            "name": "entityType"
          },
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "kind": "ScalarField",
            "name": "isFavourite"
          }
        ]
      },
      {
        "args": (v9/*: any*/),
        "concreteType": "UpdateConnection",
        "kind": "LinkedField",
        "name": "updatesForSavedView",
        "plural": false,
        "selections": [
          {
            "concreteType": "UpdateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v17/*: any*/),
                      {
                        "concreteType": "Project",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          (v8/*: any*/),
                          (v19/*: any*/),
                          (v7/*: any*/),
                          (v20/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "private"
                          },
                          {
                            "concreteType": "IconURIs",
                            "kind": "LinkedField",
                            "name": "iconUrl",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "ThemeURIs",
                                "kind": "LinkedField",
                                "name": "square",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "light"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "dark"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "transparent"
                                  }
                                ]
                              }
                            ]
                          },
                          (v21/*: any*/),
                          (v6/*: any*/),
                          {
                            "concreteType": "ProjectUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": (v23/*: any*/)
                          },
                          (v24/*: any*/)
                        ]
                      },
                      (v18/*: any*/),
                      (v22/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDate"
                      },
                      {
                        "concreteType": "ProjectChangelogItem",
                        "kind": "LinkedField",
                        "name": "changelog",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "newValue"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "oldValue"
                          },
                          (v7/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "LearningConnection",
                        "kind": "LinkedField",
                        "name": "learnings",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "LearningEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Learning",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v25/*: any*/),
                                  (v8/*: any*/),
                                  (v7/*: any*/),
                                  (v26/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "description"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v18/*: any*/),
                                      {
                                        "concreteType": "Project",
                                        "kind": "LinkedField",
                                        "name": "project",
                                        "plural": false,
                                        "selections": (v27/*: any*/)
                                      },
                                      {
                                        "concreteType": "Goal",
                                        "kind": "LinkedField",
                                        "name": "goal",
                                        "plural": false,
                                        "selections": (v27/*: any*/)
                                      },
                                      {
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "creator",
                                        "plural": false,
                                        "selections": (v28/*: any*/)
                                      },
                                      (v22/*: any*/),
                                      {
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "lastEditedBy",
                                        "plural": false,
                                        "selections": (v28/*: any*/)
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "lastEditedDate"
                                      }
                                    ],
                                    "type": "Highlight",
                                    "abstractKey": "__isHighlight"
                                  }
                                ]
                              }
                            ]
                          },
                          (v29/*: any*/)
                        ]
                      },
                      (v31/*: any*/),
                      (v30/*: any*/),
                      (v32/*: any*/),
                      (v38/*: any*/),
                      {
                        "concreteType": "ProjectState",
                        "kind": "LinkedField",
                        "name": "newState",
                        "plural": false,
                        "selections": [
                          (v39/*: any*/),
                          (v33/*: any*/),
                          (v35/*: any*/),
                          (v41/*: any*/)
                        ]
                      },
                      (v26/*: any*/),
                      {
                        "concreteType": "UpdateNote",
                        "kind": "LinkedField",
                        "name": "notes",
                        "plural": true,
                        "selections": [
                          (v8/*: any*/),
                          (v42/*: any*/),
                          (v43/*: any*/),
                          (v26/*: any*/),
                          (v7/*: any*/),
                          (v10/*: any*/)
                        ]
                      },
                      (v44/*: any*/),
                      {
                        "concreteType": "ProjectState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": [
                          (v33/*: any*/),
                          (v35/*: any*/),
                          (v39/*: any*/),
                          (v41/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "MilestoneConnection",
                        "kind": "LinkedField",
                        "name": "milestones",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "MilestoneEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Milestone",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  (v7/*: any*/),
                                  (v43/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "targetDate"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "targetDateType"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "status"
                                  }
                                ]
                              }
                            ]
                          },
                          (v29/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v45/*: any*/),
                              {
                                "concreteType": "Goal",
                                "kind": "LinkedField",
                                "name": "goal",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/),
                                  (v7/*: any*/)
                                ]
                              }
                            ],
                            "type": "GoalUpdate"
                          }
                        ],
                        "type": "Update",
                        "abstractKey": "__isUpdate"
                      }
                    ],
                    "type": "ProjectUpdate"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v17/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      {
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          (v8/*: any*/),
                          (v19/*: any*/),
                          (v7/*: any*/),
                          (v20/*: any*/),
                          {
                            "concreteType": "Goal",
                            "kind": "LinkedField",
                            "name": "parentGoal",
                            "plural": false,
                            "selections": (v46/*: any*/)
                          },
                          (v21/*: any*/),
                          (v6/*: any*/),
                          {
                            "concreteType": "GoalIcon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "appearance"
                              }
                            ]
                          },
                          {
                            "concreteType": "GoalUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": (v23/*: any*/)
                          },
                          (v24/*: any*/),
                          {
                            "concreteType": "GoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": [
                              (v29/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "MetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "MetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "MetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "startValue"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "targetValue"
                                      },
                                      (v7/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "GoalState",
                        "kind": "LinkedField",
                        "name": "newState",
                        "plural": false,
                        "selections": [
                          (v40/*: any*/),
                          (v47/*: any*/),
                          (v48/*: any*/),
                          (v49/*: any*/),
                          (v35/*: any*/),
                          (v50/*: any*/)
                        ]
                      },
                      (v18/*: any*/),
                      (v22/*: any*/),
                      {
                        "concreteType": "GoalMetricUpdateConnection",
                        "kind": "LinkedField",
                        "name": "metricUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GoalMetricUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "GoalMetricUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "newStartValue"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newTargetValue"
                                  },
                                  {
                                    "concreteType": "MetricValue",
                                    "kind": "LinkedField",
                                    "name": "newValue",
                                    "plural": false,
                                    "selections": (v51/*: any*/)
                                  },
                                  {
                                    "concreteType": "Metric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v6/*: any*/),
                                      (v25/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "subType"
                                      },
                                      (v42/*: any*/)
                                    ]
                                  },
                                  {
                                    "concreteType": "MetricValue",
                                    "kind": "LinkedField",
                                    "name": "oldValue",
                                    "plural": false,
                                    "selections": (v51/*: any*/)
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "GoalProgress",
                        "kind": "LinkedField",
                        "name": "newProgress",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "percentage"
                          }
                        ]
                      },
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v30/*: any*/),
                      (v38/*: any*/),
                      (v26/*: any*/),
                      {
                        "concreteType": "UpdateNote",
                        "kind": "LinkedField",
                        "name": "notes",
                        "plural": true,
                        "selections": [
                          (v42/*: any*/),
                          (v8/*: any*/),
                          (v43/*: any*/),
                          (v26/*: any*/),
                          (v7/*: any*/)
                        ]
                      },
                      (v44/*: any*/),
                      {
                        "concreteType": "GoalState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": [
                          (v49/*: any*/),
                          (v35/*: any*/),
                          (v47/*: any*/),
                          (v48/*: any*/),
                          (v50/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v45/*: any*/)
                            ],
                            "type": "GoalUpdate"
                          }
                        ],
                        "type": "Update",
                        "abstractKey": "__isUpdate"
                      }
                    ],
                    "type": "GoalUpdate"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v46/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              },
              (v10/*: any*/),
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      {
        "args": (v9/*: any*/),
        "filters": [
          "viewUuid",
          "workspaceUuid"
        ],
        "handle": "connection",
        "key": "SavedViewUpdatesFeed_updatesForSavedView",
        "kind": "LinkedHandle",
        "name": "updatesForSavedView"
      }
    ]
  },
  "params": {
    "cacheID": "b7fb3edb473379857e0e1874f2ed6202",
    "id": null,
    "metadata": {},
    "name": "SavedViewUpdatesQuery",
    "operationKind": "query",
    "text": "query SavedViewUpdatesQuery(\n  $workspaceUuid: UUID!\n  $viewUuid: UUID!\n  $isNavRefreshEnabled: Boolean!\n) {\n  ...SavedViewUpdatesMainColumn_3Na6m3\n  ...SavedViewSidebarColumn_3Na6m3 @skip(if: $isNavRefreshEnabled)\n}\n\nfragment Comment on Comment {\n  id\n  ari\n  commentText\n  creationDate\n  editDate\n  creator {\n    aaid\n    ...UserAvatar\n    id\n  }\n}\n\nfragment Comments on CommentConnection {\n  edges {\n    node {\n      id\n      editDate\n      ...Comment\n    }\n  }\n}\n\nfragment GoalDateChanged on GoalUpdate {\n  oldDueDate {\n    ...TargetDate\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalFollowButton on Goal {\n  id\n  uuid\n  watching\n}\n\nfragment GoalMissedUpdateLabel on GoalUpdate {\n  creationDate\n  missedUpdate\n  updateType\n  goal {\n    id\n    key\n    latestUserUpdate {\n      id\n      creationDate\n    }\n    latestUpdateDate\n  }\n}\n\nfragment GoalProgressChanged on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        metric {\n          type\n          subType\n          archived\n          id\n        }\n        newStartValue\n        newValue {\n          value\n          id\n        }\n        oldValue {\n          value\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalState on GoalState {\n  label(includeScore: false)\n  localizedLabel {\n    messageId\n  }\n  score\n  goalStateValue: value\n  atCompletionState {\n    label(includeScore: false)\n    localizedLabel {\n      messageId\n    }\n    value\n    score\n  }\n}\n\nfragment GoalStatusChanged on GoalUpdate {\n  newState {\n    ...GoalState\n  }\n  oldState {\n    ...GoalState\n  }\n}\n\nfragment GoalUpdateCard on GoalUpdate {\n  id\n  uuid\n  creator {\n    aaid\n    id\n  }\n  missedUpdate\n  updateType\n  ...MissedGoalUpdateCard\n  ...GoalUpdateCardInternal\n  goal {\n    uuid\n    id\n  }\n}\n\nfragment GoalUpdateCardFooter on GoalUpdate {\n  id\n  ari\n  updateType\n  missedUpdate\n  goal {\n    ari\n    ...GoalFollowButton\n    id\n  }\n  ...ShareUpdateButton\n}\n\nfragment GoalUpdateCardHeader on GoalUpdate {\n  id\n  newState {\n    value\n    score\n  }\n  goal {\n    ...GoalFollowButton\n    parentGoal {\n      id\n    }\n    key\n    name\n    ...PlatformGoalIcon\n    id\n  }\n}\n\nfragment GoalUpdateCardInternal on GoalUpdate {\n  id\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop\n  ...GoalUpdateSummary\n  notes {\n    ...UpdateNote\n    id\n  }\n  ...GoalUpdateDiff\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment GoalUpdateCardProgress on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        newStartValue\n        newTargetValue\n        newValue {\n          value\n          id\n        }\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n        }\n      }\n    }\n  }\n  newProgress {\n    type\n    percentage\n  }\n  goal {\n    id\n    subGoals {\n      count\n    }\n    metricTargets {\n      edges {\n        node {\n          startValue\n          targetValue\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalUpdateCardTop on GoalUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...GoalUpdateCreationDate\n  ...GoalUpdateStatus\n  ...GoalMissedUpdateLabel\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateCardTop_PTxnb on GoalUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...GoalMissedUpdateLabel\n  missedUpdate\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateCreationDate on GoalUpdate {\n  id\n  goal {\n    key\n    id\n  }\n  creator {\n    aaid\n    id\n  }\n  lastEditedBy {\n    aaid\n    pii {\n      name\n    }\n    id\n  }\n  creationDate\n  editDate\n}\n\nfragment GoalUpdateDiff on GoalUpdate {\n  ...GoalDateChanged\n  ...GoalStatusChanged\n  ...GoalProgressChanged\n}\n\nfragment GoalUpdateStatus on GoalUpdate {\n  newState {\n    goalStateValue: value\n    ...GoalState\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalUpdateSummary on GoalUpdate {\n  summary\n}\n\nfragment LearningCard_cardQuery on Learning {\n  uuid\n  id\n  summary\n  description\n  type\n  ...LearningModifierSignatures_data\n}\n\nfragment LearningModifierSignatures_data on Highlight {\n  __isHighlight: __typename\n  uuid\n  ari\n  project {\n    key\n    ari\n    id\n  }\n  goal {\n    key\n    ari\n    id\n  }\n  creator {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  creationDate\n  lastEditedBy {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  lastEditedDate\n}\n\nfragment LearningsSummary_data on ProjectUpdate {\n  learnings {\n    edges {\n      node {\n        type\n        ...LearningCard_cardQuery\n        id\n      }\n    }\n  }\n}\n\nfragment MilestoneCard_cardQuery on Milestone {\n  uuid\n  ...MilestoneFields\n}\n\nfragment MilestoneFields on Milestone {\n  id\n  title\n  targetDate\n  targetDateType\n  status\n}\n\nfragment MilestonesSummary_data on ProjectUpdate {\n  milestones {\n    edges {\n      node {\n        ...MilestoneCard_cardQuery\n        id\n      }\n    }\n  }\n}\n\nfragment MissedGoalUpdateCard on GoalUpdate {\n  id\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop_PTxnb\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment MissedProjectUpdateCard on ProjectUpdate {\n  id\n  uuid\n  project {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...ProjectUpdateCardHeader\n  ...ProjectUpdateCardTop_PTxnb\n  ...ProjectUpdateTargetDateAutoUpdated\n  ...LearningsSummary_data\n  ...ProjectUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment ProjectDateChanged on ProjectUpdate {\n  oldDueDate {\n    ...TargetDate\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment ProjectFollowButton on Project {\n  id\n  uuid\n  watching\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectMissedUpdateLabel on ProjectUpdate {\n  creationDate\n  missedUpdate\n  updateType\n  project {\n    id\n    key\n    latestUserUpdate {\n      id\n      creationDate\n    }\n    latestUpdateDate\n  }\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  projectStateValue: value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment ProjectStatusChanged on ProjectUpdate {\n  newState {\n    ...ProjectState\n  }\n  oldState {\n    ...ProjectState\n  }\n}\n\nfragment ProjectUpdateCard on ProjectUpdate {\n  id\n  uuid\n  missedUpdate\n  updateType\n  creator {\n    aaid\n    id\n  }\n  ...MissedProjectUpdateCard\n  ...ProjectUpdateCardInternal\n  project {\n    uuid\n    id\n  }\n  milestones {\n    count\n  }\n  learnings {\n    count\n  }\n  notes {\n    __typename\n    id\n  }\n}\n\nfragment ProjectUpdateCardContentExtras on ProjectUpdate {\n  ...ProjectUpdateNotes\n  ...ProjectUpdateDiff\n  ...LearningsSummary_data\n  ...MilestonesSummary_data\n  ...ProjectUpdateTargetDateAutoUpdated\n}\n\nfragment ProjectUpdateCardFooter on ProjectUpdate {\n  ari\n  updateType\n  missedUpdate\n  project {\n    ari\n    ...ProjectFollowButton\n    id\n  }\n  ...ShareUpdateButton\n}\n\nfragment ProjectUpdateCardHeader on ProjectUpdate {\n  project {\n    ...ProjectFollowButton\n    ...ProjectIcon\n    id\n    key\n    name\n  }\n}\n\nfragment ProjectUpdateCardInternal on ProjectUpdate {\n  id\n  project {\n    uuid\n    ari\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...ProjectUpdateCardHeader\n  ...ProjectUpdateCardTop\n  ...ProjectUpdateSummary\n  ...ProjectUpdateCardContentExtras\n  ...ProjectUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment ProjectUpdateCardTop on ProjectUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...ProjectUpdateCreationDate\n  ...ProjectUpdateStatus\n  ...ProjectMissedUpdateLabel\n}\n\nfragment ProjectUpdateCardTop_PTxnb on ProjectUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...ProjectMissedUpdateLabel\n  missedUpdate\n}\n\nfragment ProjectUpdateCreationDate on ProjectUpdate {\n  id\n  project {\n    key\n    id\n  }\n  creationDate\n  editDate\n  creator {\n    aaid\n    id\n  }\n  lastEditedBy {\n    aaid\n    pii {\n      name\n    }\n    id\n  }\n}\n\nfragment ProjectUpdateDiff on ProjectUpdate {\n  ...ProjectDateChanged\n  ...ProjectStatusChanged\n}\n\nfragment ProjectUpdateNotes on ProjectUpdate {\n  notes {\n    uuid\n    ...UpdateNote\n    id\n  }\n}\n\nfragment ProjectUpdateStatus on ProjectUpdate {\n  newDueDate {\n    ...TargetDate\n  }\n  newState {\n    projectStateValue: value\n    ...ProjectState\n  }\n}\n\nfragment ProjectUpdateSummary on ProjectUpdate {\n  summary\n}\n\nfragment ProjectUpdateTargetDateAutoUpdated on ProjectUpdate {\n  project {\n    key\n    id\n  }\n  newTargetDate\n  changelog {\n    newValue\n    oldValue\n    id\n  }\n}\n\nfragment SavedViewSidebarColumn_3Na6m3 on Query {\n  directoryViewByUuid(workspaceUuid: $workspaceUuid, uuid: $viewUuid) {\n    uuid\n    entityType\n    id\n  }\n}\n\nfragment SavedViewUpdatesFeed_3Na6m3 on Query {\n  updatesForSavedView(viewUuid: $viewUuid, workspaceUuid: $workspaceUuid, first: 10) {\n    ...UpdatesFeed\n    edges {\n      __typename\n      cursor\n      node {\n        __typename\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment SavedViewUpdatesHeader_3Na6m3 on Query {\n  directoryViewByUuid(workspaceUuid: $workspaceUuid, uuid: $viewUuid) {\n    id\n    name\n    uuid\n    entityType\n    isFavourite\n  }\n}\n\nfragment SavedViewUpdatesMainColumn_3Na6m3 on Query {\n  directoryViewByUuid(workspaceUuid: $workspaceUuid, uuid: $viewUuid) {\n    name\n    entityType\n    id\n  }\n  ...SavedViewUpdatesHeader_3Na6m3\n  ...SavedViewUpdatesFeed_3Na6m3\n}\n\nfragment ShareUpdateButton on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n  }\n  ... on GoalUpdate {\n    id\n  }\n  ...ShareUpdateDialogContent\n}\n\nfragment ShareUpdateDialogContent on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n    project {\n      key\n      id\n    }\n  }\n  ... on GoalUpdate {\n    id\n    url\n    goal {\n      key\n      id\n    }\n  }\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment UpdateNote on UpdateNote {\n  archived\n  uuid\n  title\n  summary\n}\n\nfragment UpdatesFeed on UpdateConnection {\n  edges {\n    node {\n      __typename\n      ... on ProjectUpdate {\n        id\n        ...ProjectUpdateCard\n      }\n      ... on GoalUpdate {\n        id\n        ...GoalUpdateCard\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment UserAvatar on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n\nfragment UserName on User {\n  aaid\n  pii {\n    name\n    accountStatus\n  }\n}\n"
  }
};
})();

(node as any).hash = "c76f3a930fb26f4df2fee515aa0fa7b0";

export default node;
